const translations = {
    loading: 'Loading...',
    noContact: 'No contact available',
    title: 'Person of Contact'
};

export default translations;
